const MEMBER_PREFIX = 'member:'

export const STORAGE_KEY = {
  showStickyData: `${MEMBER_PREFIX}showStickyData`,
  stickyDataId: `${MEMBER_PREFIX}stickyDataId`,
  myInfoTimestamp: `${MEMBER_PREFIX}myInfoTimestamp`,
  showNoPvDialog: `${MEMBER_PREFIX}showNoPvDialog`,
  categoryState: `${MEMBER_PREFIX}dashboardCategoryState`
}

const KEY = 'APP_DATA'

class StorageManager {
  constructor (type = 'local') {
    this.userNum = null
    this.data = {
      user: {}
    }

    switch (type) {
      case 'local':
        this.storage = localStorage
        break
      case 'session':
        this.storage = sessionStorage
        break
      default:
        throw new Error(`invalid storage type: ${type}`)
    }

    const oldData = this.storage.getItem(KEY)

    if (oldData !== null) {
      this.data = JSON.parse(oldData)
    }
  }

  initUser (userNum) {
    this.userNum = userNum
    if (!this.data.user[userNum]) {
      this.data.user[userNum] = {}
    }
  }

  sync () {
    this.storage.setItem(KEY, JSON.stringify(this.data))
  }

  _getTarget (key) {
    let data = this.data

    if (key.indexOf(MEMBER_PREFIX) === 0) {
      if (!this.userNum) {
        throw new Error('no MEMBER_PREFIX')
      }
      data = data.user[this.userNum]
      key = key.replace(MEMBER_PREFIX, '')
    }

    return {
      key,
      data
    }
  }

  setItem (key, value, manualSync = false) {
    if (value === undefined) {
      console.warn('setItem value is undefined')
      return
    }

    const target = this._getTarget(key)
    target.data[target.key] = value

    if (!manualSync) {
      this.sync()
    }
  }

  getItem (key) {
    const target = this._getTarget(key)
    let value = target.data[target.key]

    if (value === undefined) {
      value = null
    }
    return value
  }

  removeItem (key, manualSync) {
    const target = this._getTarget(key)
    delete target.data[target.key]

    if (!manualSync) {
      this.sync()
    }
    this.sync()
  }

  // only called when deactivate
  removeUserData () {
    delete this.data.user[this.userNum]
    this.sync()
  }
}

export const storageManager = new StorageManager()
